import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import TermsOfUseModal from './TermsOfUseModal';
import { fetchLogin } from '../../../Actions/Authentication';
import { showLoading } from '../../../Actions/Page';
import { auth } from '../../../Service/Firebase';
import { GoogleAuthProvider, signInWithPopup, getAdditionalUserInfo } from 'firebase/auth';
import { showError } from '../../../Actions/Message';
import { useHistory } from 'react-router-dom';
import ReactGA from 'react-ga';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Input, Checkbox, Button, Divider } from 'antd';
import { registerMember } from '../../../Actions/Authentication';

import { ReactComponent as UsernameIcon } from '../../../assets/icons/username.svg';
import { ReactComponent as EmailIcon } from '../../../assets/icons/email.svg';
import { ReactComponent as PasswordIcon } from '../../../assets/icons/password.svg';
import { ReactComponent as GoogleIcon } from '../../../assets/icons/google.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/icons/facebook.svg';

ReactGA.pageview(window.location.pathname + window.location.search);

const Register = ({ ...props }) => {
   const dispatch = useDispatch();
   const history = useHistory();
   const { toLogin, location } = props;
   const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);
   const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

   const schema = yup.object({
      username: yup.string().required('กรุณากรอกชื่อโปรไฟล์'),
      email: yup
         .string()
         .required('กรุณากรอกอีเมลหรือเบอร์โทรศัพท์')
         .test('email-or-phone', 'อีเมลหรือเบอร์โทรศัพท์ไม่ถูกต้อง', function (value) {
            if (!value) return false;

            // Check if it's a valid email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isEmail = emailRegex.test(value);

            // Check if it's a valid Thai phone number (0XXXXXXXXX)
            const phoneRegex = /^[0][0-9]{9}$/;
            const isPhone = phoneRegex.test(value);

            return isEmail || isPhone;
         }),
      password: yup.string().required('กรุณากรอกรหัสผ่าน'),
      acceptPrivacyPolicy: yup
         .boolean()
         .oneOf(
            [true],
            'กรุณาอ่านและกดยอมรับนโยบายความเป็นส่วนตัว และ เงื่อนไขการใช้บริการ ก่อนกดสมัครสมาชิกทุกช่องทาง'
         ),
      acceptTermsOfUse: yup
         .boolean()
         .oneOf(
            [true],
            'กรุณาอ่านและกดยอมรับนโยบายความเป็นส่วนตัว และ เงื่อนไขการใช้บริการ ก่อนกดสมัครสมาชิกทุกช่องทาง'
         )
   });

   const formik = useFormik({
      initialValues: {
         username: '',
         email: '',
         password: '',
         acceptPrivacyPolicy: false,
         acceptTermsOfUse: false
      },
      validationSchema: schema,
      onSubmit: (values) => {
         const payload = {
            email: values.email,
            password: values.password,
            displayName: values.username
         };
         dispatch(registerMember(payload, location.pathname));
      }
   });

   const handleChangePolicy = (e) => {
      if (e.target.checked) {
         setIsPolicyModalOpen(true);
      } else {
         formik.setFieldValue('acceptPrivacyPolicy', false);
      }
   };

   const handleChangeTerms = (e) => {
      if (e.target.checked) {
         setIsTermsModalOpen(true);
      } else {
         formik.setFieldValue('acceptTermsOfUse', false);
      }
   };

   const handleToLogin = () => {
      if (window.innerWidth > 900) {
         toLogin();
      } else {
         history.push('/login');
      }
   };

   const facebookLoginHandle = (result, data) => {
      if (!formik.values.acceptPrivacyPolicy || !formik.values.acceptTermsOfUse) {
         dispatch(
            showError({
               message: 'กรุณาอ่านและยอมรับนโยบายความเป็นส่วนตัว และ เงื่อนไขการใช้บริการ ก่อนกดสมัครสมาชิกทุกช่องทาง'
            })
         );
         return;
      }

      if (result && formik.values.acceptPrivacyPolicy && formik.values.acceptTermsOfUse) {
         dispatch(fetchLogin('facebook', data.user, history));
         dispatch(showLoading(false));
      } else {
         dispatch(
            showError({
               message: 'กรุณาอ่านและยอมรับนโยบายความเป็นส่วนตัว และ เงื่อนไขการใช้บริการ ก่อนกดสมัครสมาชิกทุกช่องทาง'
            })
         );
      }
   };

   const googleLoginHandle = () => {
      if (!formik.values.acceptPrivacyPolicy || !formik.values.acceptTermsOfUse) {
         dispatch(
            showError({
               message: 'กรุณาอ่านและยอมรับนโยบายความเป็นส่วนตัว และ เงื่อนไขการใช้บริการ ก่อนกดสมัครสมาชิกทุกช่องทาง'
            })
         );
         return;
      }
      const provider = new GoogleAuthProvider();
      auth.languageCode = 'th';
      signInWithPopup(auth, provider)
         .then((result) => {
            const user = getAdditionalUserInfo(result).profile;
            const payload = {
               id: user.id,
               email: user.email,
               name: user.name,
               picture: user.picture,
               given_name: user.given_name,
               family_name: user.family_name
            };
            dispatch(fetchLogin('gmail', payload));
         })
         .catch((error) => {
            dispatch(showError({ message: `Gmail Login Error ${error.message}` }));
         });
   };

   return (
      <div className='register-container'>
         <h1>สมัครสมาชิก</h1>
         <form className='register-form' onSubmit={formik.handleSubmit}>
            <div className='form-group'>
               <label htmlFor='username'>ชื่อโปรไฟล์ (*)</label>
               <Input
                  id='username'
                  name='username'
                  className={formik.touched.username && formik.errors.username ? 'error' : ''}
                  prefix={<UsernameIcon />}
                  placeholder='กรอกชื่อโปรไฟล์'
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
               />
               {formik.touched.username && formik.errors.username && <p className='error'>{formik.errors.username}</p>}
            </div>

            <div className='form-group'>
               <label htmlFor='email'>อีเมล หรือ เบอร์โทรศัพท์ (*)</label>
               <Input
                  type='text'
                  id='email'
                  name='email'
                  className={formik.touched.email && formik.errors.email ? 'error' : ''}
                  prefix={<EmailIcon />}
                  placeholder='กรอกอีเมล หรือ เบอร์โทรศัพท์'
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
               />
               {formik.touched.email && formik.errors.email && <p className='error'>{formik.errors.email}</p>}
            </div>
            <div className='form-group'>
               <label htmlFor='password'>รหัสผ่าน (*)</label>
               <Input.Password
                  id='password'
                  name='password'
                  className={formik.touched.password && formik.errors.password ? 'error' : ''}
                  prefix={<PasswordIcon />}
                  placeholder='กรอกรหัสผ่าน'
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
               />
               {formik.touched.password && formik.errors.password && <p className='error'>{formik.errors.password}</p>}
            </div>
            <div className='form-group'>
               <div className='checkbox-group'>
                  <Checkbox
                     checked={formik.values.acceptPrivacyPolicy}
                     onChange={handleChangePolicy}
                     onBlur={formik.handleBlur}
                  >
                     ฉันอ่านและยอมรับ <span className='underline'>นโยบายความเป็นส่วนตัว</span>
                  </Checkbox>

                  <Checkbox
                     checked={formik.values.acceptTermsOfUse}
                     onChange={handleChangeTerms}
                     onBlur={formik.handleBlur}
                  >
                     ฉันอ่านและยอมรับ <span className='underline'>เงื่อนไขการใช้บริการ</span>
                  </Checkbox>
               </div>
               {(formik.touched.acceptPrivacyPolicy && formik.errors.acceptPrivacyPolicy) ||
               (formik.touched.acceptTermsOfUse && formik.errors.acceptTermsOfUse) ? (
                  <p className='error'>{formik.errors.acceptPrivacyPolicy || formik.errors.acceptTermsOfUse}</p>
               ) : null}
            </div>

            <Button type='primary' htmlType='submit' size='large'>
               สมัครสมาชิก
            </Button>
         </form>
         {/* <Divider style={{ margin: '2rem 0' }}>หรือ</Divider> */}
         {/* <div className='register-sso-button-group'>
            <Button size='large' onClick={googleLoginHandle}>
               <GoogleIcon />
               Google
            </Button>
            <FacebookLogin onLogin={facebookLoginHandle}>
               <Button size='large'>
                  <FacebookIcon />
                  Facebook
               </Button>
            </FacebookLogin>
         </div> */}
         <p className='already-have-account'>
            คุณมีบัญชีอยู่แล้ว? <span onClick={handleToLogin}>เข้าสู่ระบบ</span>
         </p>
         <PrivacyPolicyModal
            visible={isPolicyModalOpen}
            onCancel={() => setIsPolicyModalOpen(false)}
            handleAcceptPolicy={() => {
               formik.setFieldValue('acceptPrivacyPolicy', true);
               setIsPolicyModalOpen(false);
            }}
         />
         <TermsOfUseModal
            visible={isTermsModalOpen}
            onCancel={() => setIsTermsModalOpen(false)}
            handleAcceptTerms={() => {
               formik.setFieldValue('acceptTermsOfUse', true);
               setIsTermsModalOpen(false);
            }}
         />
      </div>
   );
};

export default Register;
